import { FeaturesFacade } from './../../../store/features/facades/features.facade';
import { selectViewProfile } from './../../../store/user/selectors/user.selectors';
import { ViewProfileState } from './../../../store/user/reducers/user.view.reducer';
import { IAppState } from './../../../store/state/app.state';
import { Component, OnInit, ElementRef, OnDestroy, AfterViewInit, Renderer2 } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { Subscription, Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import * as UserActions from '../../../store/user/actions/user.actions';
import { selectChangePasswordLoading } from 'src/app/store/auth/selectors/auth.selectors';
import { AppConfig } from 'src/app/app.config';
import { Features } from '../../../models/features';
import { TokenService } from 'src/app/services/token/token.service';
import { UserRoleType } from "src/app/models/userRoleTypes";
import {AuthService} from "../../../services/http/auth.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy, AfterViewInit {

  opened = false;
  active = false;
  sidebarWidth = 0;
  sidebarInPos: string;
  appContainerEl: ElementRef;
  appContainerHTMLElement: HTMLElement;
  userSubscription: Subscription;
  authSubscription: Subscription;
  routerSubscription: Subscription;
  showSpinner: boolean;
  showProfileTab: boolean = AppConfig.settings.features[Features.ACCOUNT_SETTINGS].showProfileTab;
  showTaxDetailsTab$: Observable<boolean> = this.featuresFacade.isFeatureEnabledForUser$(Features.TAX_DETAILS);
  showAddressDetailsTab$: Observable<boolean> = this.featuresFacade.isFeatureEnabledForUser$(Features.ADDRESS_DETAILS);
  public showInvitations: boolean;
  public showBankAccounts: boolean;
  private isAdministrator: boolean;
  private isAdvisor: boolean;
  private managerId: number;

  constructor(private renderer: Renderer2, private eRef: ElementRef, private router: Router, private store: Store<IAppState>, private featuresFacade: FeaturesFacade,
    private tokenService: TokenService, private appConfig: AppConfig, private authService: AuthService)
    {
      this.isAdministrator = this.tokenService.isAdministrator();
      this.isAdvisor = this.authService.doesUserHaveRole(UserRoleType.Advisor);
      this.managerId = this.tokenService.getManagerId();
      this.showInvitations = this.checkInvitationsEnabled();
      this.showBankAccounts = this.checkBankAccountsEnabled();
    }

  ngOnInit() {
    // first, set the scroll position of the body to 0
    window.scrollTo(0, 0);
    const element = this.eRef.nativeElement.querySelectorAll('.sidebar-container');
    this.sidebarInPos = -element[0].offsetWidth + 'px';
    setTimeout(() => {
      this.store.dispatch(new UserActions.UserProfileEdit());
    }, 0);

    this.userSubscription = this.store.pipe(select(selectViewProfile))
      .subscribe((viewProfile: ViewProfileState) => {
        if (!viewProfile) {
          return;
        }

        this.opened = viewProfile.editMode;
        this.showHideSidebar(this.opened);
      });

    this.authSubscription = this.store.pipe(select(selectChangePasswordLoading)).subscribe((loading: boolean) => {
      this.showSpinner = loading;
    });

    this.routerSubscription = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd && event.url !== undefined) {
        if (event.url.indexOf('sidebar') === -1) {
          this.showHideSidebar(false);
        }
      }
    });
  }

  ngAfterViewInit() {
    this.appContainerHTMLElement = document.querySelector('body');
  }

  closeSideBar() {
    if (!this.showSpinner) {
      setTimeout(() => {
        this.router.navigate([{ outlets: { 'sidebar': null } }]);
      }, 300);
      this.store.dispatch(new UserActions.UserProfileEditClose());
    }
  }

  showHideSidebar(bSidebarOpened: boolean) {
    if (this.appContainerHTMLElement === undefined) {
      return;
    }

    if (bSidebarOpened) {
      // hide scrollbar
      this.renderer.setStyle(this.appContainerHTMLElement, 'overflow', 'hidden');
    } else {
      // show scrollbar
      this.renderer.setStyle(this.appContainerHTMLElement, 'overflow', 'visible');
    }
  }

  private checkInvitationsEnabled() {
    if (this.isAdministrator || this.isAdvisor) {
      return false;
    } else {
      return this.appConfig.getSection(Features.INVITATIONS)
        ?.enabledManagers.includes(this.managerId)
    }
  }

  private checkBankAccountsEnabled() : boolean {
    if (this.isAdministrator || this.isAdvisor) {
      return false;
    } 
    return true;
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    this.authSubscription.unsubscribe();
  }


}
